import styled from '@emotion/styled';
import { message, Modal, ModalProps } from 'antd';
import useCrud from 'hooks/useCrud';
import { useEffect, useRef, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { buyerDetailList, BuyerDetailListParams } from '../service';
import DetailTable from './DetailTable';

const Content = styled.div`
  margin-top: -10px;
  margin-bottom: -20px;
`;

export interface DetailModalProps extends ModalProps {
  month: string | number;
  storeId: string;
  storeName?: string;
  buyerSummary: AeOverview.BuyerSummary;
}

function DetailModal(props: DetailModalProps) {
  const { month, storeId, storeName, buyerSummary, ...otherProps } = props;

  const { t } = useTranslate();

  const { buyerId, buyerNick } = buyerSummary;

  const [page, setPage] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const { loading, list, fetchList } = useCrud({
    readList: (props: BuyerDetailListParams) =>
      buyerDetailList(props).then((res) => {
        const { details, total } = res;

        const { pageNum, pageSize } = props;

        setPage({
          current: pageNum,
          pageSize,
          total,
        });

        return details;
      }),
  });

  const refsCurrent = {
    fetchList,
    t,
  };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  useEffect(() => {
    refs.current
      .fetchList({
        month,
        storeId,
        buyerId,
        pageNum: 1,
        pageSize: 10,
      })
      .catch(() => {
        message.error(refs.current.t('phrase.获取数据失败，请稍后再试'));
      });
  }, [buyerId, storeId, month]);

  const table = (
    <DetailTable
      loading={loading}
      dataSource={list}
      pagination={{
        ...page,
        showSizeChanger: false,
        showTotal: (x) => t('feedback.共x项', { x }),
        onChange: (pageNum, pageSize) => {
          fetchList({
            month,
            storeId,
            buyerId,
            pageNum,
            pageSize,
          }).catch(() => {
            message.error(t('phrase.获取数据失败，请稍后再试'));
          });
        },
      }}
    />
  );

  return (
    <Modal
      title={`${t('marketing.查看明细')}(${storeName ? `${storeName}-` : ''}${buyerNick})`}
      footer={null}
      width={660}
      {...otherProps}
    >
      <Content>{table}</Content>
    </Modal>
  );
}

export default DetailModal;
